import { atom } from "recoil";
import { keysOfRecoil } from "../../store/recoil/keys";
import { Undefinable } from "@types";
import { Nullable } from "@becon-team/becon-fe-lib/my-types";

type TScannerInfo = {
  connectStatus: "needBluetoothConnect" | "complete" | "currentWifi" | "currentCable";
  device: Nullable<{
    name: string;
    wifiName: string;
    battery: number;
    os: string;
    needUpdate: boolean;
    changeFlag: boolean;
  }>;
};

export const scannerState = atom<Undefinable<TScannerInfo>>({
  key: keysOfRecoil.SCALP_SCANNER_INFO,
  default: undefined,
});
